module.exports = __webpack_public_path__ + "static/media/DragAndDrop.a382f8e0.svg";